import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import ReceiptIcon from "@mui/icons-material/Receipt";
import EventIcon from "@mui/icons-material/Event";
import CarCrashIcon from "@mui/icons-material/CarCrash";

const Sidebar = ({
  onUpload,
  fileCounts,
  metadata,
  onLogout,
  onOpenSettings,
  role,
  currentView,
  onViewChange,
}) => {
  return (
    <Box
      component="aside"
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0,
          mb: 5,
          "&:hover .logo-bg": { transform: "scale(1.1)" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              className="logo-bg"
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to bottom right, #f97316, #b45309)",
                borderRadius: 2,
                transform: "rotate(45deg)",
                boxShadow: 3,
                transition: "transform 0.3s",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                inset: 8,
                bgcolor: "secondary.main",
                borderRadius: 0.5,
                transform: "rotate(45deg)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: 4,
                  bgcolor: "info.main",
                  transform: "rotate(-45deg)",
                  position: "absolute",
                  top: "25%",
                }}
              />
              <Box
                sx={{
                  width: "100%",
                  height: 4,
                  bgcolor: "primary.main",
                  transform: "rotate(-45deg)",
                  position: "absolute",
                  bottom: "25%",
                }}
              />
            </Box>
            <Typography
              sx={{
                position: "relative",
                zIndex: 10,
                fontSize: "1.25rem",
                fontWeight: 900,
                fontStyle: "italic",
                color: "white",
                lineHeight: 1,
              }}
            >
              M
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 900,
                letterSpacing: "-0.05em",
                lineHeight: 1,
              }}
            >
              MOBILITY
            </Typography>
            <Typography
              sx={{
                fontSize: "0.625rem",
                fontWeight: "bold",
                color: "text.secondary",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                mt: 0.5,
              }}
            >
              MeritX Engine Pro
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box mb={4}>
        <Typography
          sx={{
            fontWeight: 900,
            color: "#64748b",
            textTransform: "uppercase",
            fontSize: "10px",
            letterSpacing: "0.2em",
            mb: 2,
            borderLeft: "2px solid #3b82f6",
            pl: 1.5,
          }}
        >
          NAVIGAZIONE
        </Typography>
        <Stack spacing={1}>
          <Button
            onClick={() => onViewChange("dashboard")}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              fontSize: "11px",
              fontWeight: 900,
              color: currentView === "dashboard" ? "white" : "#94a3b8",
              bgcolor: currentView === "dashboard" ? "#1e293b" : "transparent",
              border: "1px solid",
              borderColor:
                currentView === "dashboard" ? "#3b82f6" : "transparent",
              "&:hover": {
                bgcolor: "#1e293b",
                color: "white",
              },
              px: 2,
              py: 1.2,
              borderRadius: "12px",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Analisi MeritocraticX
          </Button>
          <Button
            onClick={() => onViewChange("brokerinsight")}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              fontSize: "11px",
              fontWeight: 900,
              color: currentView === "brokerinsight" ? "white" : "#94a3b8",
              bgcolor:
                currentView === "brokerinsight" ? "#1e293b" : "transparent",
              border: "1px solid",
              borderColor:
                currentView === "brokerinsight" ? "#f97316" : "transparent",
              "&:hover": {
                bgcolor: "#1e293b",
                color: "white",
              },
              px: 2,
              py: 1.2,
              borderRadius: "12px",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Rinnovi Analytics
          </Button>
        </Stack>
      </Box>

      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 4, flexGrow: 1 }}
      >
        {role === "Admin" && (
          <Box>
            <Typography
              sx={{
                fontSize: "0.625rem",
                fontWeight: 900,
                color: "text.secondary",
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                mb: 2,
                borderLeft: 2,
                borderColor: "primary.main",
                pl: 1.5,
              }}
            >
              CARICAMENTO DATI
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <FileUploader
                label="Report Produzione"
                count={fileCounts.prod}
                meta={metadata?.production}
                onFileChange={(f) => onUpload("production", f)}
                icon={
                  <ReceiptIcon
                    className="icon"
                    sx={{
                      color: "#64748b",
                      transition: "color 0.3s",
                      fontSize: 16,
                    }}
                  />
                }
                activeColor="primary.main"
              />
              <FileUploader
                label="Report Scadenze"
                count={fileCounts.exp}
                meta={metadata?.expiries}
                onFileChange={(f) => onUpload("expiries", f)}
                icon={
                  <EventIcon
                    className="icon"
                    sx={{
                      color: "#64748b",
                      transition: "color 0.3s",
                      fontSize: 16,
                    }}
                  />
                }
                activeColor="primary.main"
              />
              <FileUploader
                label="Targhe Perse"
                count={fileCounts.lost}
                meta={metadata?.lost}
                onFileChange={(f) => onUpload("lost", f)}
                icon={
                  <CarCrashIcon
                    className="icon"
                    sx={{
                      color: "#64748b",
                      transition: "color 0.3s",
                      fontSize: 16,
                    }}
                  />
                }
                activeColor="primary.main"
              />
            </Box>
          </Box>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, pt: 2 }}>
          {role === "Admin" && (
            <Button
              onClick={onOpenSettings}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                p: 1.5,
                borderRadius: 3,
                border: 1,
                "&:hover": {
                  borderColor: "primary.main",
                  bgcolor: "rgba(30, 41, 59, 0.8)",
                  "& .icon": { color: "primary.main" },
                },
                textTransform: "uppercase",
                fontWeight: 900,
                fontSize: "0.75rem",
              }}
              startIcon={
                <SettingsIcon
                  className="icon"
                  sx={{ color: "#64748b", transition: "color 0.3s" }}
                />
              }
            >
              Impostazioni
            </Button>
          )}
          <Button
            onClick={onLogout}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              p: 1.5,
              borderRadius: 3,
              border: 1,
              "&:hover": {
                borderColor: "error.main",
                bgcolor: "rgba(30, 41, 59, 0.8)",
                "& .icon": { color: "error.main" },
              },
              textTransform: "uppercase",
              fontWeight: 900,
              fontSize: "0.75rem",
            }}
            startIcon={
              <LogoutIcon
                className="icon"
                sx={{ color: "#64748b", transition: "color 0.3s" }}
              />
            }
          >
            Esci
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          pt: 3,
          fontSize: "0.625rem",
          color: "grey.500",
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "0.1em",
        }}
      >
        <Typography variant="inherit">© 2024 Mobility MeritX Hub</Typography>
        <Typography variant="inherit" sx={{ mt: 1, color: "grey.600" }}>
          Engine Version 3.1.0
        </Typography>
      </Box>
    </Box>
  );
};

const FileUploader = ({
  label,
  count,
  meta,
  onFileChange,
  icon,
  activeColor,
}) => {
  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: 3,
        border: 1,
        borderColor: "rgba(51, 65, 85, 0.5)",
        "&:hover": {
          borderColor: activeColor,
          "& .icon": { color: "primary.light" },
        },
        transition: "all 0.3s",
      }}
      elevation={0}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {icon}
          <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold" }}>
            {label}
          </Typography>
        </Box>
        {count > 0 && (
          <Box
            sx={{
              fontSize: "0.5625rem",
              bgcolor: "rgba(249, 115, 22, 0.1)",
              color: "primary.light",
              px: 1,
              py: 0.25,
              borderRadius: 4,
              border: 1,
              borderColor: "rgba(249, 115, 22, 0.2)",
              fontWeight: 900,
            }}
          >
            LIVE
          </Box>
        )}
      </Box>
      <Box component="label" sx={{ display: "block", mb: 1 }}>
        <Typography sx={{ srOnly: true }}>Scegli file</Typography>
        <input
          type="file"
          accept=".csv"
          onChange={(e) =>
            e.target.files?.[0] && onFileChange(e.target.files[0])
          }
          style={{
            display: "block",
            width: "100%",
            fontSize: "0.625rem",
            color: "#64748b",
            cursor: "pointer",
          }}
          className="file-input"
        />
        <style>
          {`
            .file-input::file-selector-button {
              margin-right: 16px;
              padding: 4px 12px;
              border-radius: 9999px;
              border: none;
              font-size: 9px;
              font-weight: 900;
              text-transform: uppercase;
              background-color: #334155;
              color: #cbd5e1;
              cursor: pointer;
              transition: all 0.3s;
            }
            .file-input:hover::file-selector-button {
              background-color: #ea580c;
              color: white;
            }
          `}
        </style>
      </Box>
      {meta && (
        <Box
          sx={{
            mt: 1,
            pt: 1,
            borderTop: 1,
            borderColor: "rgba(51, 65, 85, 0.5)",
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.5625rem",
              color: "grey.400",
              fontWeight: 900,
              textTransform: "uppercase",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {meta.name}
          </Typography>
          <Typography
            sx={{
              fontSize: "0.5rem",
              color: "grey.600",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "-0.02em",
            }}
          >
            {meta.timestamp}
          </Typography>
          <Typography
            sx={{
              fontSize: "0.5625rem",
              color: "grey.500",
              fontWeight: "bold",
              fontStyle: "italic",
              textTransform: "uppercase",
            }}
          >
            {count} righe caricate
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default Sidebar;
